import { ReactNode } from 'react';

import { IBaseSwitcherProps } from '@r1-frontend/ui-react/components/controls/baseSwitcher';
import SimpleBaseSwitcher from '@r1-frontend/ui-react/components/controls/baseSwitcher/SimpleBaseSwitcher';
import BaseSubscription from '@r1-frontend/ui-react/organisms/TariffSubscription/BaseSubscription';
import { TBaseSubscriptionProps } from '@r1-frontend/ui-react/organisms/TariffSubscription/BaseSubscription/BaseSubscription';

export type TSwitchableSubscriptionProps = {
    children: string | JSX.Element | ReactNode,
    switcherAlign?: 'start' | 'center',
    onIconClick: () => void,
    onToggle: (event: React.ChangeEvent<HTMLInputElement>, state?: boolean) => void,

    className?: string,
} & Omit<TBaseSubscriptionProps, 'onClick'> & Pick<IBaseSwitcherProps, 'checked' | 'disabled' | 'required'>

const SwitchableSubscription = ({
    children,
    description,

    cost,
    oldCost,
    onIconClick,
    onToggle,
    Icon,
    iconSize,

    checked,
    disabled,
    required,

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    switcherAlign,

    ...props
}: TSwitchableSubscriptionProps): JSX.Element => {

    return (
        <div {...props} data-test={'SwitchableSubscription'}>
            <BaseSubscription
                description={description}
                Icon={Icon}
                cost={cost}
                oldCost={oldCost}
                onClick={onIconClick}
                iconSize={iconSize}
            >
                {children}
            </BaseSubscription>
            <SimpleBaseSwitcher
                checked={checked}
                disabled={disabled}
                required={required}
                onChange={onToggle}
            />
        </div>
    );
};

export default SwitchableSubscription;
